import { useState, useCallback } from 'react'
import { copyToClipboard } from '@/utils/helpers.js'

export function useClipboard(resetMs = 2000) {
  const [copied, setCopied] = useState(false)

  const copy = useCallback(
    async (text) => {
      try {
        await copyToClipboard(text)
        setCopied(true)
        setTimeout(() => setCopied(false), resetMs)
      } catch (err) {
        console.error('[useClipboard] Failed to copy:', err)
      }
    },
    [resetMs]
  )

  return { copied, copy }
}
